import { render, staticRenderFns } from "./StockTrfNew_Details.vue?vue&type=template&id=bf73be2e&"
import script from "./StockTrfNew_Details.vue?vue&type=script&lang=js&"
export * from "./StockTrfNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports